import { useFilePicker } from '../../../../../v2BaseComponents/ImagePicker';
import { BulkAddClientRecord, CSVHeaders, csvHeaders, csvHeadersMap } from '../types';

export type UseUploadCSVArgs = {
    onUpload: (csvData: BulkAddClientRecord[]) => void;
};

export type UseUploadCSVReturnValue = {
    onPress: () => void;
    E2EInput: React.ReactElement | null;
};

const parseCSV = (csvText: string): BulkAddClientRecord[] => {
    const records: BulkAddClientRecord[] = [];
    const lines = csvText.split(/\r?\n/);
    const headers = lines[0].split(',');
    for (let lineIndex = 1; lineIndex < lines.length; lineIndex++) {
        const record: BulkAddClientRecord = {
            clientFirstName: '',
            clientLastName: '',
            clientDOB: '',
            clientPreferredName: '',
            pointOfContactEmail: '',
            pointOfContactFirstName: '',
            pointOfContactLastName: '',
            pointOfContactPreferredName: '',
            pointOfContactPhoneNumber: '',
        };
        for (let headerIndex = 0; headerIndex < headers.length; headerIndex++) {
            const values = lines[lineIndex].split(',');
            const header = headers[headerIndex];
            const value = values[headerIndex];
            if (csvHeaders.includes(header as any)) {
                const prop = csvHeadersMap[header as CSVHeaders];
                record[prop] = value;
            }
        }
        records.push(record);
    }

    return records;
};

export const useUploadCSV = (args: UseUploadCSVArgs): UseUploadCSVReturnValue => {
    const { onPress, E2EInput } = useFilePicker({
        onPick: (value) => {
            const csvText = atob(value.base64);
            const csvData = parseCSV(csvText);
            args.onUpload(csvData);
        },
        documentPickerOptions: {
            type: 'text/csv',
        },
        isLoadingFile: false,
    });

    return {
        onPress,
        E2EInput,
    };
};
